export default "__VITE_ASSET__R2170905__"